export default __webpack_public_path__ + "static/media/guitar_amp_bg.deb449ba.webp";